import React from 'react'
import PlaceholderPage from '../../components/shared/PlaceholderPage'
import { Target } from 'lucide-react'

const features = [
  { name: 'Lead Profile', description: 'Complete lead information and history' },
  { name: 'Activity Timeline', description: 'All interactions and touchpoints' },
  { name: 'Score & Stage', description: 'Lead score and pipeline position' },
  { name: 'Conversion Actions', description: 'Convert to customer or archive' },
]

export default function LeadDetailView() {
  return (
    <PlaceholderPage
      title="Lead Details"
      description="View and manage individual leads"
      icon={Target}
      features={features}
      accentColor="amber"
    />
  )
}
